export default "__VITE_ASSET__4f68332f__"